import React from "react";
import { FaWhatsapp } from "react-icons/fa6";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { httpReauest } from "api/api";
import { toast } from "react-toastify";
import * as Yup from "yup";

const ContactForm = ({ noname }) => {
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      name: Yup.string().required(t("required")),
      content: Yup.string().required(t("required")),
      phone: Yup.string()
        .min(11, "Wrong format")
        .max(11, "Wrong format")
        .required(t("required")),
    });
  };

  const formik = useFormik({
    validationSchema: VALUE_SIGN_VALIDATION,
    initialValues: { name: "", phone: "", content: "" },
    onSubmit: async (values) => {
      await httpReauest("POST", "/send", values, {}).then((res) => {
        toast.success("اطلاعات ارسال شد");
        navigate("/projects");
        formik.resetForm();
      });
    },
  });

  return (
    <section className="contact bg-white rounded shadow py-10 px-6">
      <div
        className="container mx-auto"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        {!noname && (
          <div
            dir="rtl"
            className="mb-6"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <a
                target="_blank"
                href="https://wa.me/971589157089"
                className="flex items-center gap-4 bg-gray-100 p-4 rounded shadow hover:bg-green-50"
              >
                <FaWhatsapp size={30} className="text-green-500" />
                <div>
                  <h3 className="font-bold">Whatsapp</h3>
                  <p className="text-sm" dir="ltr">
                    +971 58 915 7089
                  </p>
                </div>
              </a>
              <a
                href="tel:+971501926568"
                className="flex items-center gap-4 bg-gray-100 p-4 rounded shadow hover:bg-blue-50"
              >
                <i className="bi bi-telephone text-blue-500 text-xl" />
                <div>
                  <h3 className="font-bold">Call</h3>
                  <p dir="ltr" className="text-sm">
                    +971 50 192 6568
                  </p>
                </div>
              </a>
              <a
                href="mailto:info@epskan.com"
                className="flex items-center gap-4 bg-gray-100 p-4 rounded shadow"
              >
                <i className="bi bi-envelope text-purple-500 text-xl" />
                <div>
                  <h3 className="font-bold">Email</h3>
                  <p className="text-sm">info@epskan.com</p>
                </div>
              </a>
            </div>
          </div>
        )}

        <form
          className="space-y-4"
          dir="rtl"
          data-aos="fade-up"
          data-aos-delay="300"
          onSubmit={formik.handleSubmit}
        >
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <input
                type="text"
                name="name"
                id="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
                className="form-control w-full border border-gray-300 p-3 rounded"
                placeholder={t("form-name")}
              />
              {formik.errors.name && formik.touched.name && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.name}
                </p>
              )}
            </div>

            <div>
              <input
                type="text"
                name="phone"
                id="phone"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone}
                className="form-control w-full border border-gray-300 p-3 rounded"
                placeholder={t("form-phone")}
              />
              {formik.errors.phone && formik.touched.phone && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.phone}
                </p>
              )}
            </div>
          </div>

          <div>
            <textarea
              name="content"
              id="content"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.content}
              className="form-control w-full border border-gray-300 p-3 rounded h-32"
              placeholder={t("form-text")}
            />
            {formik.errors.content && formik.touched.content && (
              <p className="text-red-500 text-sm mt-1">
                {formik.errors.content}
              </p>
            )}
          </div>

          <div className="text-center">
            <button className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition">
              {t("submit")}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
